// extracted by mini-css-extract-plugin
module.exports = {"hidden":"D1l8iYhoBEwdM85iTJ-o"};